import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate('/auth');
        return;
      }
      const sessionId = match[1];

      try {
        const { data } = await api.post('/auth/google-session', { session_id: sessionId });

        if (data.needs_registration) {
          // Navigate to auth page with Google data pre-filled
          navigate('/auth', {
            state: {
              googleAuth: true,
              tempToken: data.temp_token,
              email: data.email,
              googleName: data.google_name,
              googlePicture: data.google_picture
            }
          });
        } else {
          login(data.user, data.token);
          // Clear hash and redirect
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/browse');
        }
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/auth');
      }
    };

    processSession();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#9EABCE] text-sm">Signing you in with Google...</p>
      </div>
    </div>
  );
}
